import axios from 'axios'
import jwt_decode from 'jwt-decode';
import config from '../../utils/Config';

const login = async (userData) => {
    const response = await axios.post(config.basePath + 'user/signIn', userData);
    return response.data;
}

const register = async (userData) => {
    const response = await axios.post(config.basePath + 'user/register', userData);
    return response.data;
}

const setToken = (token) => {
    localStorage.setItem('token', token)
}

const getToken = () => {
    return localStorage.getItem('token')
}

const setRole = (role) => {
    localStorage.setItem('role', role)
}

const setAdminname = (name) => {
    localStorage.setItem('adminname', name);
}

const getAdminname = () => {
    localStorage.getItem('adminname');
}

const getRole = () => {
    return localStorage.getItem('role')
}


const setDist = (districtId) => {
    localStorage.setItem('districtId', districtId)
}

const getDist = () => {
    return localStorage.getItem('districtId')
}

const setUserId = (userId) => {
    localStorage.setItem('userId', userId)
}

const getUserId = (userId) => {
    return localStorage.getItem('userId')
}


const isLoggedIn = () => {
    let token = getToken();
    if (token) {
        let decodedToken = jwt_decode(token);
        // console.log("Decoded Token", decodedToken);
        let currentDate = new Date();

        if (decodedToken.exp * 1000 < currentDate.getTime()) {
            localStorage.clear()
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}
const logout = () => {
    localStorage.clear()
}

const checkUserExists = async (email) => {
    console.log(email)
    const response = await axios.post(config.basePath + 'user/checkuser',{'email': email});
    return response.data;
}

const authService = {
    register,
    login,
    logout,
    isLoggedIn,
    setToken,
    getToken, 
    setRole, 
    getRole,
    setDist,
    getDist,
    setUserId,
    getUserId,
    setAdminname,
    checkUserExists
}

export default authService